'use client'

import { cn } from '../lib/cn'

const ENERGY_OPTIONS = [
  { value: 1 as const, label: 'Very Low', description: 'I need something really gentle' },
  { value: 2 as const, label: 'Low', description: 'Easy and restorative' },
  { value: 3 as const, label: 'Medium', description: 'Steady, balanced practice' },
  { value: 4 as const, label: 'High', description: 'Ready to move and challenge' },
  { value: 5 as const, label: 'Very High', description: 'Bring it on' },
]

export interface EnergyPickerProps {
  value: number | undefined
  onChange: (value: number) => void
  className?: string
}

export function EnergyPicker({ value, onChange, className }: EnergyPickerProps) {
  return (
    <fieldset
      className={cn('flex flex-col gap-3 border-0 p-0 m-0', className)}
      aria-label="Energy level"
    >
      {ENERGY_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          onClick={() => onChange(opt.value)}
          className={cn(
            'flex items-center gap-4 rounded-2xl px-5 py-4 text-left',
            'border transition-all duration-200',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-400',
            value === opt.value
              ? 'border-terracotta-400 bg-terracotta-400/5 shadow-warm-sm'
              : 'border-cream-200 bg-white hover:border-cream-200 hover:bg-cream-50'
          )}
        >
          <span
            className={cn(
              'w-4 h-4 rounded-full border-2 flex-shrink-0 transition-colors',
              value === opt.value
                ? 'border-terracotta-500 bg-terracotta-500'
                : 'border-warm-gray-400 bg-transparent'
            )}
            aria-hidden="true"
          />
          <div>
            <div className="font-medium text-warm-gray-800">{opt.label}</div>
            <div className="text-sm text-warm-gray-400">{opt.description}</div>
          </div>
        </button>
      ))}
    </fieldset>
  )
}
